import React, { useEffect, useState } from 'react'
import { registerSW } from 'virtual:pwa-register'
import { WifiOff, RefreshCw } from 'lucide-react'

const PWAStatus: React.FC = () => {
    const [needRefresh, setNeedRefresh] = useState(false)
    const [updateFunction, setUpdateFunction] = useState<((reloadPage?: boolean) => Promise<void>) | null>(null)
    const [isOnline, setIsOnline] = useState(navigator.onLine)
    const [showBanner, setShowBanner] = useState(false)

    useEffect(() => {
        // Handle online/offline status
        const handleOnline = () => setIsOnline(true)
        const handleOffline = () => setIsOnline(false)

        window.addEventListener('online', handleOnline)
        window.addEventListener('offline', handleOffline)

        // Register Service Worker
        const updateSW = registerSW({
            onNeedRefresh() {
                console.log('🔄 PWA: New content available')
                setNeedRefresh(true)
                setUpdateFunction(() => updateSW)
                setShowBanner(true)
            },
            onOfflineReady() {
                console.log('PWA: service worker registered')
            },
            onRegisterError(error) {
                console.error('❌ PWA: SW registration error', error)
            },
        })

        return () => {
            window.removeEventListener('online', handleOnline)
            window.removeEventListener('offline', handleOffline)
        }
    }, [needRefresh])

    const handleRefresh = () => {
        if (updateFunction) {
            updateFunction(true)
        }
    }

    const closeBanner = () => {
        setShowBanner(false)
    }

    if (!showBanner && isOnline) return null

    return (
        <>
            {/* Offline Indicator (Always show small at bottom when offline) */}
            {!isOnline && (
                <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-96 z-50 bg-red-500 text-white p-4 rounded-lg shadow-lg flex items-center justify-between animate-fade-in">
                    <div className="flex items-center gap-3">
                        <WifiOff className="w-6 h-6" />
                        <div>
                            <p className="font-bold text-lg">Mất kết nối mạng</p>
                            <p className="text-sm opacity-90">Một số chức năng cần kết nối Internet để hoạt động.</p>
                        </div>
                    </div>
                </div>
            )}

            {/* Update Available Banner (Keep as banner but larger) */}
            {showBanner && needRefresh && (
                <div className="fixed top-4 left-1/2 transform -translate-x-1/2 w-[90%] max-w-md z-50 bg-blue-600 text-white p-6 rounded-xl shadow-2xl flex flex-col gap-4 animate-slide-down">
                    <div className="flex items-center gap-4">
                        <RefreshCw className="w-8 h-8 animate-spin-slow" />
                        <div>
                            <p className="font-bold text-xl">Có bản cập nhật mới</p>
                            <p className="text-base opacity-90">Tải lại để áp dụng thay đổi</p>
                        </div>
                    </div>
                    <div className="flex gap-3 justify-end">
                        <button
                            onClick={closeBanner}
                            className="px-4 py-2 rounded-lg text-white hover:bg-blue-700 transition-colors"
                        >
                            Để sau
                        </button>
                        <button
                            onClick={handleRefresh}
                            className="bg-white text-blue-600 px-6 py-2 rounded-lg font-bold hover:bg-blue-50 transition-colors shadow-md"
                        >
                            Tải lại ngay
                        </button>
                    </div>
                </div>
            )}

        </>
    )
}

export default PWAStatus
